<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <b-form-group class="w-50 mb-0">
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Wyszukaj po nazwie, cenie" />
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''"> Wyczyść </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div class="d-flex flex-gap">
        <b-button
          :to="{ name: 'delivery-methods-additional-information' }"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="btn mr-2">
          Dodatkowe informacje
        </b-button>
        <b-button
          :to="{ name: 'delivery-methods-create' }"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="btn">
          Dodaj
        </b-button>
      </div>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="deliveryMethods"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn">
      <template #cell(actions)="row">
        <div class="d-flex flex-column align-items-center">
          <b-button
            :to="{ name: 'delivery-methods-edit', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Edytuj
          </b-button>
          <b-button class="mt-1 table-btn" variant="danger" size="sm" @click="destroy(row.item)"> Usuń </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all, destroy } from '@/http/delivery-methods';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      deliveryMethods: [],
      filter: '',
      filterOn: [],
      fields: [
        { key: 'company_name', label: 'Nazwa', sortable: true },
        { key: 'price', label: 'Koszt', sortable: true },
        { key: 'actions', label: 'Akcje', class: 'w-25' },
      ],
    };
  },

  async mounted() {
    await this.fetchDeliveryMethods();
  },

  methods: {
    async fetchDeliveryMethods() {
      try {
        const { data } = await all({ lang: 'pl' });

        this.deliveryMethods = data.data;
      } catch (error) {
        this.showErrorNotification(
          'Problem z pobraniem danych',
          'Wystąpił błąd podczas pobierania metod dostawy. Skontaktuj się ze swoim developerem.',
        );
      }
    },
    destroy(jobOffer) {
      this.$swal({
        title: 'Jesteś pewny?',
        text: 'Czy chcesz usunąć tę metodę dostawy?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        cancelButtonText: 'Anuluj',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          destroy(jobOffer.id)
            .then(() => {
              this.showSuccessNotification('Metoda dostawy usunięta', 'Metoda dostawy została pomyślnie usunięta.');
              this.fetchDeliveryMethods();
            })
            .catch(() => {
              this.showErrorNotification(
                'Problem z usunięciem metody dostawy',
                'Wystąpił błąd podczas usuwania metody dostawy. Skontaktuj się ze swoim developerem.',
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
